import { frontendURL } from 'dashboard/helper/URLHelper';
import ResultGalleryIndex from './pages/ResultGalleryIndex.vue';

const resultGalleryRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/result-gallery'),
      name: 'result_gallery_index',
      meta: {
        permissions: ['administrator', 'agent'],
      },
      component: ResultGalleryIndex,
    },
  ],
};

export default resultGalleryRoutes;
